import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import API from "../../services/api";

import {
    FaArrowLeft,
    FaPhone,
    FaEnvelope,
    FaMapMarkerAlt,
    FaCalendarAlt,
    FaCheckCircle,
    FaTimesCircle
} from "react-icons/fa";

import DirectDueModal from "./DirectDueModal";

function CustomerProfile() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [customer, setCustomer] = useState(null);

    const [summary, setSummary] = useState({
        invoice_due: 0,
        direct_due: 0,
        total_due: 0,
        total_invoices: 0
    });

    const [invoiceHistory, setInvoiceHistory] = useState([]);

    const [directDueHistory, setDirectDueHistory] = useState([]);

    const [page, setPage] = useState(1);

    const [pages, setPages] = useState(1);

    const [search, setSearch] = useState("");

    const [loading, setLoading] = useState(true);

    const [showDueModal, setShowDueModal] =
        useState(false);

    useEffect(() => {

        loadCustomer();

    }, [page, search]);

    const loadCustomer = async () => {

        try {

            const token =
                localStorage.getItem(
                    "adminToken"
                );

            const res =
                await API.get(
                    `/customers/${id}/profile?page=${page}&search=${search}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`
                        }
                    }
                );

            setCustomer(
                res.data.customer
            );

            setSummary(
                res.data.summary
            );

            setInvoiceHistory(
                res.data.invoiceHistory
            );

            setDirectDueHistory(
                res.data.directDueHistory
            );

            setPages(
                res.data.pages
            );

        } catch (err) {

            console.log(err);

        } finally {

            setLoading(false);

        }

    };

    if (loading) {

        return (

            <div className="flex justify-center items-center h-[500px]">

                <div className="text-2xl font-semibold">

                    Loading...

                </div>

            </div>

        );

    }

    if (!customer) {

        return (

            <div className="flex justify-center items-center h-[500px]">

                <div className="text-red-500 text-2xl">

                    Customer Not Found

                </div>

            </div>

        );

    }

    return (

        <div>

            {/* Header */}

            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5 mb-8">

                <div>

                    <h1 className="text-4xl font-bold">

                        Customer Details

                    </h1>

                    <p className="text-gray-500 mt-2">

                        Complete Customer Information

                    </p>

                </div>

                <div className="flex gap-3">

                    <button
                        onClick={() =>
                            setShowDueModal(true)
                        }
                        className="
                        px-5
                        py-3
                        rounded-xl
                        bg-green-600
                        hover:bg-green-700
                        font-semibold
                        "
                    >
                        Update Direct Due
                    </button>

                    <Link
                        to="/admin/customers"
                        className="
                        flex
                        items-center
                        gap-2
                        px-5
                        py-3
                        rounded-xl
                        bg-yellow-500
                        text-black
                        font-semibold
                        "
                    >

                        <FaArrowLeft />

                        Back

                    </Link>

                </div>

            </div>

            {/* Customer Profile */}

            <div
                className="
                bg-[#111]
                rounded-3xl
                border
                border-yellow-500/20
                p-8
                mb-8
                "
            >

                <div className="flex flex-col lg:flex-row items-center gap-8">

                    <div
                        className="
                        w-32
                        h-32
                        rounded-full
                        bg-yellow-500
                        text-black
                        text-5xl
                        font-bold
                        flex
                        items-center
                        justify-center
                        "
                    >

                        {
                            customer.customer_name
                                ?.charAt(0)
                                ?.toUpperCase()
                        }

                    </div>

                    <div className="flex-1">

                        <h2 className="text-4xl font-bold">

                            {
                                customer.customer_name
                            }

                        </h2>

                        <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-5">

                            <div className="flex items-center gap-3">

                                <FaPhone className="text-yellow-500" />

                                <span>

                                    {customer.phone}

                                </span>

                            </div>

                            <div className="flex items-center gap-3">

                                <FaEnvelope className="text-yellow-500" />

                                <span>

                                    {customer.email || "-"}

                                </span>

                            </div>

                            <div className="flex items-center gap-3">

                                <FaMapMarkerAlt className="text-yellow-500" />

                                <span>

                                    {customer.address || "-"}

                                </span>

                            </div>

                            <div className="flex items-center gap-3">

                                <FaCalendarAlt className="text-yellow-500" />

                                <span>

                                    {
                                        new Date(
                                            customer.created_at
                                        ).toLocaleDateString()
                                    }

                                </span>

                            </div>

                            <div>

                                <span className="text-gray-400">

                                    GST :

                                </span>

                                <span className="ml-2">

                                    {
                                        customer.gst_no || "-"
                                    }

                                </span>

                            </div>

                        </div>

                    </div>

                    <div>

                        {
                            Number(customer.status) === 1 ?

                                <span
                                    className="
                                    bg-green-500/20
                                    text-green-400
                                    px-5
                                    py-2
                                    rounded-full
                                    flex
                                    items-center
                                    gap-2
                                    "
                                >

                                    <FaCheckCircle />

                                    Active

                                </span>

                                :

                                <span
                                    className="
                                    bg-red-500/20
                                    text-red-400
                                    px-5
                                    py-2
                                    rounded-full
                                    flex
                                    items-center
                                    gap-2
                                    "
                                >

                                    <FaTimesCircle />

                                    Inactive

                                </span>

                        }

                    </div>

                </div>

            </div>

                        {/* =========================
                SUMMARY CARDS
            ========================== */}

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">

                <div className="bg-[#111] rounded-2xl border border-red-500/20 p-6">

                    <p className="text-gray-400 text-sm">
                        Invoice Due
                    </p>

                    <h2 className="text-3xl font-bold text-red-400 mt-2">
                        ₹
                        {Number(
                            summary.invoice_due || 0
                        ).toFixed(2)}
                    </h2>

                </div>

                <div className="bg-[#111] rounded-2xl border border-yellow-500/20 p-6">

                    <p className="text-gray-400 text-sm">
                        Direct Due
                    </p>

                    <h2 className="text-3xl font-bold text-yellow-400 mt-2">
                        ₹
                        {Number(
                            summary.direct_due || 0
                        ).toFixed(2)}
                    </h2>

                </div>

                <div className="bg-[#111] rounded-2xl border border-green-500/20 p-6">

                    <p className="text-gray-400 text-sm">
                        Total Outstanding
                    </p>

                    <h2 className="text-3xl font-bold text-green-400 mt-2">
                        ₹
                        {Number(
                            summary.total_due || 0
                        ).toFixed(2)}
                    </h2>

                </div>

                <div className="bg-[#111] rounded-2xl border border-blue-500/20 p-6">

                    <p className="text-gray-400 text-sm">
                        Total Invoices
                    </p>

                    <h2 className="text-3xl font-bold text-blue-400 mt-2">
                        {summary.total_invoices || 0}
                    </h2>

                </div>

            </div>

            {/* =========================
                CUSTOMER INFORMATION
            ========================== */}

            <div className="bg-[#111] rounded-3xl border border-yellow-500/20 p-8 mb-8">

                <div className="flex items-center justify-between mb-6">

                    <h2 className="text-2xl font-bold">
                        Customer Information
                    </h2>

                </div>

                <div className="grid lg:grid-cols-2 gap-6">

                    <div>

                        <label className="text-gray-400 text-sm">
                            Customer Name
                        </label>

                        <div className="mt-1 text-lg font-semibold">
                            {customer.customer_name}
                        </div>

                    </div>

                    <div>

                        <label className="text-gray-400 text-sm">
                            Phone
                        </label>

                        <div className="mt-1 text-lg font-semibold">
                            {customer.phone}
                        </div>

                    </div>

                    <div>

                        <label className="text-gray-400 text-sm">
                            Email
                        </label>

                        <div className="mt-1 text-lg font-semibold">
                            {customer.email || "-"}
                        </div>

                    </div>

                    <div>

                        <label className="text-gray-400 text-sm">
                            GST Number
                        </label>

                        <div className="mt-1 text-lg font-semibold">
                            {customer.gst_no || "-"}
                        </div>

                    </div>

                    <div>

                        <label className="text-gray-400 text-sm">
                            Address
                        </label>

                        <div className="mt-1 text-lg font-semibold">
                            {customer.address || "-"}
                        </div>

                    </div>

                    <div>

                        <label className="text-gray-400 text-sm">
                            Status
                        </label>

                        <div className="mt-1">

                            {
                                Number(customer.status) === 1 ? (

                                    <span className="px-3 py-1 rounded-full bg-green-500/20 text-green-400">
                                        Active
                                    </span>

                                ) : (

                                    <span className="px-3 py-1 rounded-full bg-red-500/20 text-red-400">
                                        Inactive
                                    </span>

                                )
                            }

                        </div>

                    </div>

                </div>

            </div>

            {/* =========================
                INVOICE DUE LIST HEADER
            ========================== */}

            <div className="bg-[#111] rounded-3xl border border-yellow-500/20 p-8 mb-8">

                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">

                    <h2 className="text-2xl font-bold">
                        Invoice Due List
                    </h2>

                    <input
                        type="text"
                        placeholder="Search Invoice..."
                        value={search}
                        onChange={(e) =>
                            setSearch(
                                e.target.value
                            )
                        }
                        className="
                        bg-black
                        border
                        border-white/10
                        rounded-xl
                        px-4
                        py-3
                        outline-none
                        lg:w-80
                        "
                    />

                </div>

                                <div className="overflow-x-auto">

                    <table className="w-full">

                        <thead>

                            <tr className="border-b border-white/10">

                                <th className="text-left p-4">
                                    Invoice No
                                </th>

                                <th className="text-left p-4">
                                    Date
                                </th>

                                <th className="text-right p-4">
                                    Grand Total
                                </th>

                                <th className="text-right p-4">
                                    Paid
                                </th>

                                <th className="text-right p-4">
                                    Remaining
                                </th>

                                <th className="text-center p-4">
                                    Status
                                </th>

                                <th className="text-center p-4">
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {
                                invoiceHistory.length > 0 ?

                                    invoiceHistory.map((invoice) => (

                                        <tr
                                            key={invoice.id}
                                            className="border-b border-white/5 hover:bg-white/5"
                                        >

                                            <td className="p-4 font-semibold">

                                                {invoice.invoice_no}

                                            </td>

                                            <td className="p-4">

                                                {
                                                    new Date(
                                                        invoice.invoice_date
                                                    ).toLocaleDateString()
                                                }

                                            </td>

                                            <td className="p-4 text-right">

                                                ₹
                                                {Number(
                                                    invoice.grand_total
                                                ).toFixed(2)}

                                            </td>

                                            <td className="p-4 text-right text-green-400">

                                                ₹
                                                {Number(
                                                    invoice.paid_amount
                                                ).toFixed(2)}

                                            </td>

                                            <td className="p-4 text-right text-red-400 font-semibold">

                                                ₹
                                                {Number(
                                                    invoice.remaining_amount
                                                ).toFixed(2)}

                                            </td>

                                            <td className="p-4 text-center">

                                                {
                                                    invoice.payment_status === "paid" && (

                                                        <span className="px-3 py-1 rounded-full bg-green-500/20 text-green-400">

                                                            Paid

                                                        </span>

                                                    )
                                                }

                                                {
                                                    invoice.payment_status === "partial" && (

                                                        <span className="px-3 py-1 rounded-full bg-yellow-500/20 text-yellow-400">

                                                            Partial

                                                        </span>

                                                    )
                                                }

                                                {
                                                    invoice.payment_status === "pending" && (

                                                        <span className="px-3 py-1 rounded-full bg-red-500/20 text-red-400">

                                                            Pending

                                                        </span>

                                                    )
                                                }

                                            </td>

                                            <td className="p-4 text-center">

                                                {
                                                    invoice.remaining_amount > 0 &&(

                                                        <button

                                                            onClick={() =>
                                                                    navigate(
                                                                    `/admin/invoices/payment/${invoice.id}`
                                                                    )
                                                                }

                                                            className="
                                                            px-4
                                                            py-2
                                                            rounded-xl
                                                            bg-green-600
                                                            hover:bg-green-700
                                                            font-semibold
                                                            "
                                                        >

                                                            Collect Payment

                                                        </button>

                                                    )
                                                }

                                            </td>

                                        </tr>

                                    ))

                                    :

                                    <tr>

                                        <td
                                            colSpan={7}
                                            className="
                                            text-center
                                            py-10
                                            text-gray-400
                                            "
                                        >

                                            No Due Invoices Found

                                        </td>

                                    </tr>

                            }

                        </tbody>

                    </table>

                </div>

                {/* Pagination */}

                {
                    pages > 1 && (

                        <div className="flex justify-end gap-2 mt-6">

                            {
                                [...Array(pages)].map((_, index) => (

                                    <button

                                        key={index}

                                        onClick={() =>
                                            setPage(index + 1)
                                        }

                                        className={`
                                        px-4
                                        py-2
                                        rounded-lg
                                        ${
                                            page === index + 1
                                                ? "bg-yellow-500 text-black"
                                                : "bg-[#222]"
                                        }
                                        `}
                                    >

                                        {index + 1}

                                    </button>

                                ))
                            }

                        </div>

                    )
                }

            </div>
                        {/* =========================
                DIRECT DUE HISTORY
            ========================== */}

            <div className="bg-[#111] rounded-3xl border border-yellow-500/20 p-8">

                <div className="flex items-center justify-between mb-6">

                    <h2 className="text-2xl font-bold">
                        Direct Due History
                    </h2>

                    <span className="text-gray-400">
                        {directDueHistory.length} Records
                    </span>

                </div>

                <div className="overflow-x-auto">

                    <table className="w-full">

                        <thead>

                            <tr className="border-b border-white/10">

                                <th className="text-left p-4">
                                    Date
                                </th>

                                <th className="text-left p-4">
                                    Type
                                </th>

                                <th className="text-right p-4">
                                    Amount
                                </th>

                                <th className="text-right p-4">
                                    Current Due
                                </th>

                                <th className="text-left p-4">
                                    Remarks
                                </th>

                                <th className="text-left p-4">
                                    Created By
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {
                                directDueHistory.length > 0 ?

                                    directDueHistory.map((item) => (

                                        <tr
                                            key={item.id}
                                            className="
                                            border-b
                                            border-white/5
                                            hover:bg-white/5
                                            "
                                        >

                                            <td className="p-4">

                                                {
                                                    new Date(
                                                        item.created_at
                                                    ).toLocaleString()
                                                }

                                            </td>

                                            <td className="p-4">

                                                {
                                                    item.transaction_type === "due" ?

                                                        <span
                                                            className="
                                                            px-3
                                                            py-1
                                                            rounded-full
                                                            bg-red-500/20
                                                            text-red-400
                                                            "
                                                        >

                                                            Due

                                                        </span>

                                                        :

                                                        <span
                                                            className="
                                                            px-3
                                                            py-1
                                                            rounded-full
                                                            bg-green-500/20
                                                            text-green-400
                                                            "
                                                        >

                                                            Pay

                                                        </span>

                                                }

                                            </td>

                                            <td className="p-4 text-right font-semibold">

                                                ₹
                                                {
                                                    Number(
                                                        item.amount
                                                    ).toFixed(2)
                                                }

                                            </td>

                                            <td className="p-4 text-right text-yellow-400 font-bold">

                                                ₹
                                                {
                                                    Number(
                                                        item.current_due
                                                    ).toFixed(2)
                                                }

                                            </td>

                                            <td className="p-4">

                                                {
                                                    item.remarks || "-"
                                                }

                                            </td>

                                            <td className="p-4">

                                                {
                                                    item.created_by_name || "-"
                                                }

                                            </td>

                                        </tr>

                                    ))

                                    :

                                    <tr>

                                        <td
                                            colSpan={6}
                                            className="
                                            py-12
                                            text-center
                                            text-gray-500
                                            "
                                        >

                                            No Direct Due History Found

                                        </td>

                                    </tr>

                            }

                        </tbody>

                    </table>

                </div>

            </div>

            {/* =========================
                DIRECT DUE MODAL
            ========================== */}

            {
                showDueModal &&
                customer && (

                    <DirectDueModal
                        open={showDueModal}
                        customer={customer}
                        onClose={() =>
                            setShowDueModal(false)
                        }
                        onSuccess={() => {

                            loadCustomer();

                            setShowDueModal(false);

                        }}
                    />

                )
            }

        </div>

    );

}

export default CustomerProfile;